import React from 'react';
import { motion } from 'framer-motion';
const solutions = [{
  icon: '📚',
  title: 'Recetas Visuales',
  description: 'Fichas de receta ultra visuales con foto real, ingredientes claros y pasos simples. Vas a saber exactamente qué cocinar cada día.'
}, {
  icon: '🛒',
  title: 'Ingredientes Accesibles',
  description: 'Sin ingredientes raros ni importados. Todo lo que vas a necesitar lo encontrás fácil en tu verdulería, almacén o súper de barrio.'
}, {
  icon: '⚡',
  title: 'Resultados Desde el Primer Día',
  description: 'Estructura editorial tipo revista de cocina premium. Abrís el tomo, elegís una receta y la hacés hoy mismo. Sin vueltas.'
}];
export function SolutionSection() {
  return <section className="bg-[#0a0a0a] py-8 px-4" data-id="element-199">
      <div className="max-w-5xl mx-auto" data-id="element-200">
        <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-3xl font-bold text-white text-center mb-6" data-id="element-201">
          La Solución Definitiva para tu Cocina Vegetal
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3" data-id="element-202">
          {solutions.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-[#18181b] border border-zinc-800 rounded-lg p-4 relative overflow-hidden group" data-id="element-203">
              <div className="absolute top-0 left-0 w-full h-0.5 bg-emerald-600 origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-300" data-id="element-204" />
              <div className="flex items-start gap-3" data-id="element-205">
                <span className="text-2xl flex-shrink-0" data-id="element-206">{item.icon}</span>
                <div data-id="element-207">
                  <h3 className="text-sm font-bold text-white mb-1" data-id="element-208">
                    {item.title}
                  </h3>
                  <p className="text-zinc-400 text-xs leading-relaxed" data-id="element-209">
                    {item.description}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}